import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';

export default class StaffCompensationTarification extends BaseModel {
  constructor({id, distance = undefined, amount = undefined}) {
    super(id);
    this.distance = distance;
    this.amount = amount;
  }

  static get fkName() {
    return 'staff_compensation_type_id';
  }

  static get apiRoute() {
    return 'staff_compensation_tarification';
  }

  static get listPageRoute() {
    return null;
  }

  static get detailPageRoute() {
    return null;
  }

  static get createInitColumns() {
    return {
      distance: 0,
      amount: 0,
    };
  }

  static get orderKey() {
    return 'distance';
  }

  get fkName() {
    return StaffCompensationTarification.fkName;
  }

  get apiRoute() {
    return StaffCompensationTarification.apiRoute;
  }

  get detailPageRoute() {
    return StaffCompensationTarification.detailPageRoute;
  }

  get listPageRoute() {
    return StaffCompensationTarification.listPageRoute;
  }

  get createInitColumns() {
    return StaffCompensationTarification.createInitColumns;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['distance', 'amount']);
  }

  static get allAttributes() {
    return [
      new AT.DecimalAttribute({
        name: 'distance',
        validations: {required},
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.staff-compensation.distance',
          maxWidth: '1fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'amount',
        validations: {required},
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.amount',
          maxWidth: '1fr',
        },
      }),
    ];
  }
}
